import { useEffect, useState } from "react"
import { checkOverflow } from "../utils/dom";

export const ScrollArea = ({scrollElementRef, children, ...props}) => {
    const [isScrolling, setIsScrolling] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        setIsOverflowing(checkOverflow(scrollElementRef.current));
        const observer = new MutationObserver(() => {
            setIsOverflowing(checkOverflow(scrollElementRef.current));
        });
        observer.observe(scrollElementRef.current, { subtree: true, childList: true })
        return () => observer.disconnect();
    }, [])

    function handlePointerDown(e) {
        if (!isOverflowing) return;
        setIsScrolling(true);
        const controller = new AbortController();
        const stopScrolling = () => {
            setIsScrolling(false);
            controller.abort();
        }
        const scroll = (e) => {
            scrollElementRef.current.scrollBy({top: -e.movementY, left: -e.movementX});
        }
        document.addEventListener("pointerup", stopScrolling, {signal: controller.signal});
        document.addEventListener("pointercancel", stopScrolling, {signal: controller.signal});
        document.addEventListener("pointermove", scroll, {signal: controller.signal});

        return () => stopScrolling();
    }
    return <>
        <div
            onPointerDown={handlePointerDown}
            style={{...props.style, cursor: isOverflowing ? "grab" : undefined }}
        >
            {children}
        </div>
        {isScrolling && <div style={{ position: "fixed", inset: 0, height: "100%", zIndex: 999, cursor: "grabbing" }} />}
    </>
}